var exports = {
  "k": "AccessibilityTabInline.module__container___aXUycW",
};

module.exports = exports;
